module.exports = __webpack_public_path__ + "static/media/falcao_bauer.3b66c786.jpg";